import React, { useState } from "react";
import api from "@/auth/api";
import { alertSuccess, alertError } from "@/components/Alert";

const AddGiveAwayForm = ({ onSuccess, countryList, onClose }) => {
  const [formData, setFormData] = useState({
    giveAwayId: "",
    title: "",
    country: "",
    link: "",
    body: "",
    BackgroundImage: null,
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "BackgroundImage") {
      setFormData({ ...formData, [name]: files[0] });
    } else if (name === "country") {
      setFormData({ ...formData, [name]: Number(value) }); // Send as number
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.BackgroundImage) {
      alertError("Please upload a background image.");
      return;
    }

    const uploadData = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      uploadData.append(key, value);
    });
    // ✅ Put console here to see the data being sent
       console.log("Submitting GiveAway data:", formData);
     
    try {
      await api.post("/redeem/panel/GiveAway", uploadData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      
       

      alertSuccess("GiveAway added successfully!");
      if (onSuccess) onSuccess();

      setFormData({
        giveAwayId: "",
        title: "",
        country: "",
        link: "",
        body: "",
        BackgroundImage: null,
      });

      if (onClose) onClose();
    } catch (error) {
      alertError(error?.response?.data?.errors || "Something went wrong.");
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="max-w-3xl mx-auto bg-white p-1 space-y-2"
    >
      {/* GiveAway ID & Country */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div>
          <label className="block font-medium text-gray-700 mb-1 text-sm">GiveAway ID</label>
          <input
            type="text"
            name="giveAwayId"
            value={formData.giveAwayId}
            onChange={handleChange}
            required
            className="w-full border border-gray-300 rounded-lg px-2 py-1 focus:outline-none focus:ring-2 focus:ring-[var(--mainCol)]"
          />
        </div>

        <div>
          <label className="block font-medium text-gray-700 mb-1 text-sm">Country</label>
          <select
            name="country"
            value={formData.country}
            onChange={handleChange}
            required
            className="w-full border border-gray-300 rounded-lg px-2 py-1 focus:outline-none focus:ring-2 focus:ring-[var(--mainCol)]"
          >
            <option value="" disabled>
              Select Country
            </option>
            {countryList.map((c) => (
              <option key={c.id} value={c.id}>
                {c.title}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Title */}
      <div>
        <label className="block font-medium text-gray-700 mb-1 text-sm">Title</label>
        <input
          type="text"
          name="title"
          value={formData.title}
          onChange={handleChange}
          required
          className="w-full border border-gray-300 rounded-lg px-2 py-1 focus:outline-none focus:ring-2 focus:ring-[var(--mainCol)]"
        />
      </div>

      {/* Link */}
      <div>
        <label className="block font-medium text-gray-700 mb-1 text-sm">Link</label>
        <input
          type="text"
          name="link"
          value={formData.link}
          onChange={handleChange}
          required
          className="w-full border border-gray-300 rounded-lg px-2 py-1 focus:outline-none focus:ring-2 focus:ring-[var(--mainCol)]"
        />
      </div>

      {/* Body */}
      <div>
        <label className="block font-medium text-gray-700 mb-1 text-sm">Body</label>
        <textarea
          name="body"
          value={formData.body}
          onChange={handleChange}
          required
          rows={2}
          className="w-full border border-gray-300 rounded-lg px-2 py-1 focus:outline-none focus:ring-2 focus:ring-[var(--mainCol)] resize-none"
        />
      </div>

      {/* Background Image */}
      <div>
        <label className="block font-medium text-gray-700 mb-1 text-sm">Background Image</label>
        <input
          type="file"
          name="BackgroundImage"
          accept="image/*"
          onChange={handleChange}
          required
          className="w-full border border-gray-300 rounded-lg px-2 py-0 focus:outline-none focus:ring-2 focus:ring-[var(--mainCol)]"
        />
      </div>

      {/* Submit Button */}
      <div className="text-right">
        <button
          type="submit"
          className="bg-[var(--mainCol)] text-white font-semibold px-2 py-2 rounded-lg hover:bg-opacity-90 transition text-sm"
        >
          Add GiveAway
        </button>
      </div>
    </form>
  );
};

export default AddGiveAwayForm;